<template>
    <div class="bg-white rounded seek-reference-popover shadow">
        <SolutionCard :solution="displaySolution" class="hover:!bg-transparent" :order="order" :track-data="trackData" />
    </div>
</template>

<script setup lang="ts">
import SolutionCard from './SolutionCard.vue';
import type { ISolution } from './types';
import { computed } from 'vue';
import _ from 'lodash';

const props = defineProps<{
    solution: ISolution,
    order?: number,
    trackData?: Record<string, string>
}>()

/**
 * 引用卡片数据，只需要展示标题、内容、组织机构
 */
const displaySolution = computed(() => {
    const showPopoverData = _.omit(props.solution, ['PDF_IMAGE', 'PDF_IMAGE_COUNT', 'PBD', 'APD', 'PN']) as ISolution
    showPopoverData.ORG_INFO = _.slice(props.solution.ORG_INFO, 0, 1)
    return showPopoverData
})
</script>
